import type { ComponentChildren } from 'preact';

import { cx, Icon, type IconId } from '@amumin/ui-core';

import styles from './Notice.module.css';

export interface NoticeProps {
  kind?: 'info' | 'success' | 'warning' | 'error';
  children: ComponentChildren;
  /** Stabiele naam (data-name) voor tests. */
  name?: string;
}

const ICON: Record<NonNullable<NoticeProps['kind']>, IconId> = {
  info: 'info',
  success: 'circle-check',
  warning: 'triangle-alert',
  error: 'circle-alert',
};

/**
 * Melding in het formulier of bovenaan de pagina; fouten krijgen role="alert". Rustig: zachte
 * tint met icoon, de tekst blijft in de gewone tekstkleur (geen rode lappen tekst).
 */
export function Notice({ kind = 'info', children, name }: NoticeProps) {
  return (
    <div
      class={cx(
        styles.notice,
        kind === 'success' && styles.success,
        kind === 'warning' && styles.warning,
        kind === 'error' && styles.error,
      )}
      role={kind === 'error' ? 'alert' : 'status'}
      data-name={name}
      data-kind={kind}
    >
      <Icon id={ICON[kind]} size={20} class={styles.icon} />
      <div class={styles.body}>{children}</div>
    </div>
  );
}
